/*import Vue from 'vue'*/
import EventUtils from '@/utils/EventUtils.js';
import MapUtils from '@/utils/MapUtils.js';
import ConstUtils from '@/utils/ConstUtils.js';

const state = {
  list: [],
  map: {},
};

const getters = {
    results_found: state => state,
};

const actions = {
};

const mutations = {
  SOCKET_ONMESSAGE (state, event)  {
    if (event.status == EventUtils.STATUS.COMPLETE && event.statusCode == EventUtils.CODE.OK) {
      if (event.Payload && event.Payload.VehicleInspectionResultMap) {
        var inspections = event.Payload.VehicleInspectionResultMap;
        state.map = MapUtils.updateMap(inspections, state.map);
        state.list = Object.values(state.map);
      }
      if (event.Payload && event.Payload.VehicleInspectionResult) {
        var obj = event.Payload.VehicleInspectionResult;
        state.map[obj[ConstUtils.FIELDS.ID]] = obj;
        state.list = Object.values(state.map);
      }
    }
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};